import full from "../../assets/fullScreen.svg";
import popover from "../../assets/popoverScreen.svg";
import popup from "../../assets/popupScreen.svg";
import sideTab from "../../assets/sideTabScreen.svg";
import slider from "../../assets/sliderScreen.svg";
import standard from "../../assets/standardScreen.svg";
import close from "../../assets/close.svg";
import embedCopy from "../../assets/embedCopy.svg";
import { putEmbedForm } from "../../Services/API";

export const widgetConfigDetailsDefault = {
  mode: 'standard-screen',
  height: 'auto',
  width: '100%',
  name: 'Embed name'
}

export const icons: { [key: string]: string } = {
  "standard-screen": standard,
  "full-screen": full,
  "popup": popup,
  "slider": slider,
  "popover": popover,
  "side-tab": sideTab,
  "embedCopy": embedCopy,
  "close": close
};

export const getEmbeddingCode = (formId: string, id: string, cdnUrl: string) => {
  return `<div 
    id="myForm" 
    formId="${formId}" 
    formUniqueId="${id}">
</div>
<script 
    src=${cdnUrl}>
</script>`
}

export const getEmbeddingCodeReactHtml = (formId: string, id: string) => {
  return `<div 
    id="myForm" 
    formId="${formId}" 
    formUniqueId="${id}">
</div>`
}
export const getEmbeddingCodeReactJs = ( cdnUrl: string) => {
  return `const src = ${cdnUrl}
  useEffect(() => {
    let script = document.querySelector('script[src="\${src}"]');
    if (!script) {
      script = document.createElement("script");
      script.src = src;
      document.body.appendChild(script);
    }
   },[]);`
}

export const getEmbeddingCodeAngularJs = ( cdnUrl: string) => {

  return `ngAfterViewInit() {
    const script = document.createElement('script');
    script.src = '${cdnUrl}';
    document.body.appendChild(script);
  };`
}

export const handleApplyChanges = async (embedResponse: any, editUUID: any, selectedEmbed: any, fetchEmbed: any, setAlertOpener: any, setLoading: any) => {
  try {
    if (embedResponse) {
      const res = await putEmbedForm(editUUID, selectedEmbed?.config, selectedEmbed?._id);
      setLoading(true);
      if (res?.statusCode === 200) {
        setTimeout(() => {
          setLoading(false);
          setAlertOpener(true);
        }, 1000);
        setTimeout(() => {
          setAlertOpener(false);
        }, 3000);
      }
      fetchEmbed();
    }
  } catch (error) {
    console.error("Embed API error:", error);
  }

}